import React, { useEffect, useState } from "react";
import axios from "axios";
import { getAuthConfig } from "../../utils/api";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Repeat } from "lucide-react";
import { API } from "../../App";

// Renders ONLY when the business enabled recurring jobs in Business Settings.
export const RecurringJobPanel = ({ value, onChange }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let on = true;
    axios.get(`${API}/settings/business`, getAuthConfig())
      .then((r) => { if (on) setEnabled(!!r.data?.recurring_jobs_enabled); })
      .catch(() => {});
    return () => { on = false; };
  }, []);

  if (!enabled) return null;
  const isOn = !!value.is_recurring;

  return (
    <div className="rounded-xl border border-border/60 bg-muted/20 p-3 space-y-3" data-testid="recurring-job-panel">
      <div className="flex items-center justify-between gap-3">
        <div>
          <Label className="text-sm flex items-center gap-2">
            <Repeat className="w-4 h-4 text-primary" /> Recurring job
          </Label>
          <p className="text-xs text-muted-foreground mt-1">
            Automatically creates the next job for this customer — same details, no technician, status "New Lead".
          </p>
        </div>
        <Switch
          checked={isOn}
          onCheckedChange={(v) => onChange({
            is_recurring: v,
            recurring_interval_value: value.recurring_interval_value || 1,
            recurring_interval_unit: value.recurring_interval_unit || "months",
          })}
          data-testid="recurring-job-switch"
        />
      </div>
      {isOn && (
        <div className="flex items-center gap-2" data-testid="recurring-interval-row">
          <span className="text-sm text-muted-foreground">Every</span>
          <Input
            type="number" min={1} max={365} className="w-20 input-glass"
            value={value.recurring_interval_value || ""}
            onChange={(e) => onChange({ recurring_interval_value: e.target.value ? parseInt(e.target.value, 10) : "" })}
            data-testid="recurring-interval-value"
          />
          <Select
            value={value.recurring_interval_unit || "months"}
            onValueChange={(v) => onChange({ recurring_interval_unit: v })}
          >
            <SelectTrigger className="w-32 input-glass" data-testid="recurring-interval-unit">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="days">Days</SelectItem>
              <SelectItem value="weeks">Weeks</SelectItem>
              <SelectItem value="months">Months</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};

export default RecurringJobPanel;
